import { I18nComponente } from "@/types/gerais"

export const typesi18n: I18nComponente = {
  "pt-BR": {
    atributos: {
      numeroInteiro: "número inteiro",
      numeroDecimal: "número decimal",
      codigoIdentificador: "código identificador",
      texto: "texto",
      opcao: "opção",
      itensDeLista: "vários itens de lista",
      horario: "horário",
      data: "data",
      quantidadeInteira: "quantidade inteira",
      quantidadeDecimal: "quantidade decimal",
      quantidadeDeHoras: "quantidade de horas"
    }
  },
  "es-CO": {
    atributos: {
      numeroInteiro: "número entero",
      numeroDecimal: "número decimal",
      codigoIdentificador: "código identificador",
      texto: "texto",
      opcao: "opción",
      itensDeLista: "varios elementos de lista",
      horario: "hora",
      data: "fecha",
      quantidadeInteira: "cantidad entera",
      quantidadeDecimal: "cantidad decimal",
      quantidadeDeHoras: "cantidad de horas"
    }
  },
}
